module.exports = __webpack_public_path__ + "static/media/icon-character__simone-de-beauvoir.625ef1c2.svg";